import React from 'react';
import { Avatar as AntAvatar, AvatarProps as AntAvatarProps } from 'antd';
import { createUseStyles } from 'react-jss';
import { ThemeType } from 'src/theming/jssTypes';

export interface AvatarProps extends Omit<AntAvatarProps, 'shape'> {
  className?: string;
}

export interface GroupProps extends React.ComponentProps<typeof AntAvatar.Group> {
  className?: string;
}

const useStyles = createUseStyles((theme: ThemeType) => ({
  avatar: {
    backgroundColor: theme.color.semantic.brand.default.primary,
    color: theme.color.semantic.text.inverse,
    fontSize: theme.typography.fontSize.sm,
    fontWeight: theme.typography.fontWeight.medium,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    '& .ant-avatar-string': {
      fontSize: 'inherit',
      fontWeight: 'inherit',
    },
    '& .ant-avatar-icon': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
  },
  group: {
    '& .ant-avatar': {
      borderColor: theme.color.semantic.background.neutral.secondary,
    },
  },
}));

const AvatarComponent: React.FC<AvatarProps> = ({ className = '', ...rest }) => {
  const classes = useStyles();
  return <AntAvatar {...rest} shape="circle" className={`${classes.avatar} ${className}`.trim()} />;
};

const GroupComponent: React.FC<GroupProps> = ({ className = '', children, ...rest }) => {
  const classes = useStyles();
  return (
    <AntAvatar.Group {...rest} className={`${classes.group} ${className}`.trim()}>
      {children}
    </AntAvatar.Group>
  );
};

const Avatar = Object.assign(AvatarComponent, {
  Group: GroupComponent,
});

export default Avatar;
